module.exports = __webpack_public_path__ + "static/media/host-command-icon-arrow-start-kill.681cb3e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/host-command-icon-arrow-start-kill.svg
// module id = ./src/assets/images/host-command-icon-arrow-start-kill.svg
// module chunks = 0